import React from "react";
import { Grid } from "@material-ui/core";
import { observable } from "mobx";
import { observer, inject } from "mobx-react";

import { Values } from "Tools/Values";
import SimpleModal from "@src/Components/Common/SimpleModal/SimpleModal";
import { IManagementStore } from "Stores/Management/types";
import { IValuesStore } from "Stores/Values/types";
import AddIcon from "@material-ui/icons/Add";
import PermissionGroupForm from "@src/Components/Pages/Main/Content/PermissionGroups/PermissionGroupForm/PermissionGroupForm";
import { PermissionGroup } from "@src/Interfaces/Entity/PermissionGroup";
import RoundButton from "@src/Shared/Components/RoundButton/RoundButton";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
}

@inject("management", "values")
@observer
class AddGroupPermission extends React.Component<IProps> {
  @observable opened: boolean = false;

  handleOpen = () => {
    this.opened = true;
  };

  handleClose = () => {
    this.opened = false;
  };

  handleCreate = async (values: PermissionGroup) => {
    try {
      await this.props.management.savePermissionGroup(values, true);
      this.handleClose();
    } catch (error) {
      console.error(error);
    }
  };

  render() {
    const permissionGroup = new PermissionGroup();
    permissionGroup.state = this.props.values.states.Active;

    return (
      <Grid item>

        <RoundButton
            icon={<AddIcon/>}
            tooltipTitle={Values.getLocalizationValue("add")}
            onClick={() => this.handleOpen()}
            color={"green"}
        />
        
        <SimpleModal width={710} isOpened={this.opened} onClose={this.handleClose}>
          <PermissionGroupForm
            title={Values.getLocalizationValue("Add")}
            initialValues={permissionGroup}
            onClose={this.handleClose}
            onSubmit={this.handleCreate}
          />
        </SimpleModal>
      </Grid>
    );
  }
}

export default AddGroupPermission;
